import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/battery/emergencyv2.svg")